module.exports = __webpack_public_path__ + "img/long_skirt.b581ffb7.png";